import { ShieldAlert, PiggyBank, Users } from "lucide-react";
import { SectionEyebrow } from "../landing/SectionEyebrow";

const CARDS = [
  { icon: ShieldAlert, title: "Security-first lending",
    body: "Loans are protected through guarantors, collateral, and deposit/share multipliers — not through evidence that the member can actually service the loan from income or business cash flow." },
  { icon: PiggyBank, title: "Savings, not repayment capacity",
    body: "The x3/x4/x5 deposit-multiplier model sizes a loan by how much a member has saved — not by whether their income or business can support the repayment." },
  { icon: Users, title: "Risk that spreads to other members",
    body: "When a borrowing member defaults, guarantors are left repaying and collateral has to be enforced — the loss is ultimately absorbed across the membership, not contained to the borrower." },
];

export const SaccoProblem = () => (
  <section className="mx-auto max-w-6xl px-5 py-20 sm:py-24" data-testid="sacco-problem">
    <SectionEyebrow testid="sacco-problem-eyebrow">The Opportunity</SectionEyebrow>
    <h2 className="mt-6 max-w-3xl text-2xl font-extrabold leading-snug text-[#0B2A28] sm:text-3xl" data-testid="sacco-problem-heading">
      The current model asks <span className="text-[#0A8B85]">'can we recover this if it fails?'</span> — not{" "}
      <span className="text-[#0A8B85]">'will it fail in the first place?'</span>
    </h2>
    <div className="mt-12 grid gap-5 md:grid-cols-3">
      {CARDS.map(({ icon: Icon, title, body }, i) => (
        <div key={title} className="group rounded-2xl border border-neutral-200 bg-white p-7 shadow-sm transition-[transform,box-shadow] hover:-translate-y-1 hover:shadow-lg"
          data-testid={`sacco-problem-card-${i + 1}`}>
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0A8B85]/10 text-[#0A8B85] transition-colors group-hover:bg-[#0A8B85] group-hover:text-white">
            <Icon size={22} />
          </div>
          <p className="mt-5 text-base font-bold text-[#0B2A28] md:text-lg">{title}</p>
          <p className="mt-2.5 text-sm leading-relaxed text-neutral-600">{body}</p>
        </div>
      ))}
    </div>
  </section>
);
